/* eslint-disable react/require-default-props */
import { BLOCKS } from '@contentful/rich-text-types';
import PropTypes from 'prop-types';

import RichText from '../RichTextV2';
import GetAQuoteButtonOrLink from '../GetAQuoteRenewalCTA';
import { HeaderCallToAction } from '../styles';

import { CTABannerSection, Content } from './styles';

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
  },
};

const CTABanner = ({ data }) => {
  const { headingRTF, optionalButton, component } = data;
  const variant = component === 'grey' ? 'grey' : 'light';
  return (
    <CTABannerSection $variant={variant}>
      <Content>
        {headingRTF && (
          <RichText document={headingRTF} options={options} />
        )}
        {optionalButton && (
          <GetAQuoteButtonOrLink
            key={optionalButton.id}
            cta={optionalButton}
            CtaComponent={HeaderCallToAction}
            inline
            phoneNumberColor="red"
          />
        )}
      </Content>
    </CTABannerSection>
  );
};

CTABanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CTABanner;
